import { notification } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import '@ant-design/v5-patch-for-react-19';
export const useNotification = () => {
  const showSuccess = (message, description) => {
    notification.success({
      message,
      description,
      icon: <CheckCircleOutlined style={{ color: 'var(--primary)' }} />
    });
  };

  const showError = (error) => {
    notification.error({
      message: error?.response?.data?.Message || 'Operation failed',
      icon: <CloseCircleOutlined style={{ color: 'var(--primary)' }} />
    });
  };

  const showErrorWithMessage = (message, description) => {
    notification.error({
      message,
      description,
      icon: <CloseCircleOutlined style={{ color: 'var(--primary)' }} />
    });
  };

  const showWarning = (message, description) => {
    notification.warning({
      message,
      description,
      icon: <ExclamationCircleOutlined style={{ color: 'var(--primary)' }} />
    });
  };

  return { showSuccess, showError, showErrorWithMessage, showWarning };
};